'use client';

import { useMutation } from '@tanstack/react-query';
import { CONTACT_QUERIES } from '../../infrastructure/contact/utils/queries';

export const useContactService = () => {
  const useSubmitContact = () => {
    return useMutation(CONTACT_QUERIES.submit());
  };

  return {
    useSubmitContact,
  };
};
